export default "__VITE_PUBLIC_ASSET__3c5cf4bd__"